/* eslint-disable no-plusplus */
import { parseToDate } from 'brazilian-values';

export default function calculaIdade(dateString) {
  const today = new Date();
  const birthDate = parseToDate(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}
